import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemButton,
    List,
    ButtonGroup,
    ListSubheader,
    ListItem,
    ListItemText,
    Chip,
    Tooltip,
    Paper,
    Badge,
    FormControlLabel,
    FormGroup,
    Checkbox
} from '@mui/material';

import { orange, grey } from "@mui/material/colors";

import {
    LoadingButton
} from '@mui/lab';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import { CommonIcons, icons } from "../../common/CommonIcons";
import LocationSelector from "../../selector/LocationSelector"

import SearchItems from "../../dialog/SearchItems";
// import SearchDocuments from "../../dialog/SearchDocuments";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { useItems, itemTypes } from "../../../hooks/api/useItems";
import { useTranslations } from '../../../hooks/useTranslations';

import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useLocations, locationTypes, targetTypes as locationTargetTypes } from "../../../hooks/api/useLocations";
import { useStateItemRelocate } from "../../../hooks/state/loadFrom/documents/useStateItemRelocate";

import { useStateInventoryBatches } from "../../../hooks/state/useStateInventoryBatches";
import { validationSchema, initialValues, initialRowValues } from "../../../schema/documents/itemRelocateSchema";

import { useDataTransitions, transitionTypes } from "../../../hooks/state/dataTransition/useDataTransitions";

import {
    loadFromDocumentTypes,
    LoadFromDocuments
} from "../../dialog/LoadFromDocuments";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function NewItemRelocate({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    const { getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.itemRelocate.id)

    const { setSystemLoading } = useAppContextFeatures();
    const { isLoading, create, filterOperatorTypes } = useDocuments({
        documentType: documentTypes.itemRelocate,
        targetType: targetTypes.itemRelocate
    })
    // const { get: getProduct } = useItems(itemTypes.product)

    // const [ selectLocationIds, setSelectLocationIds ] = useState()
    const { updateFormikState, getFormikDependencyStates } = useStateItemRelocate()

    const availableLocations = getAvailableLocations();

    const [loadDocumentConfig, setLoadDocumentConfig] = useState({
        show: false,
        documentId: loadFromDocumentTypes.itemRelocate.id,
        documentType: loadFromDocumentTypes.itemRelocate.type,
        keyword: ""
    })

    const { catchTransition } = useDataTransitions({ transitionType: transitionTypes.fromReorderThresholdToPurchaseOrder.id })

    const { list: getLocationRacks } = useLocations({ locationType: locationTypes.rack, targetType: targetTypes.rack });

    const [rackData, setRackData] = useState()
    const [dataItemUoms, setDataItemUoms] = useState([])

    const fetchDataRacks = async (locationId) => {

        if (!locationId) return false;

        setSystemLoading(true);

        try {

            const props = {
                limit: 10000,
                skip: 0,
                sortInfo: {
                    id: "rack_name",
                    dir: -1
                }
            }

            props.parentId = locationId
            props.locationType = locationTypes.rack;

            const { data } = await getLocationRacks(props)
            // console.log('warehouseRacks', warehouseRacks, params)

            // for(let i = 0; i < data.racks.length; i+=1){
            data.racks.map(item => {

                let b = item?.slots;

                let newSlots = [];

                if (b) {

                    Object.keys(b).map((item2, index2) => {
                        // console.log('value', item2)
                        newSlots.push({
                            id: item2,
                            name: b[item2]
                        })
                        return false;
                    })
                }

                item._slots = newSlots;

                return false;
            })

            // console.log(data.racks)

            setRackData(data.racks)

        } catch (error) {

            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

        return false

    }

    // const fetchProduct = async ({ productId, index }) => {

    //     setSystemLoading(true)

    //     try {

    //         let props = {
    //             id: productId,
    //             itemType: itemTypes.product
    //         }

    //         let { data } = await getProduct(props);

    //         console.log('data --> ', data.items)

    //         if (data?.items) {
    //             setDataItemUoms(
    //                 dataItemUoms.concat(data.items)
    //             )
    //         }

    //         setSystemLoading(false)

    //     } catch (error) {
    //         promptMessage(false, `${error.message}`)
    //     }

    //     setSystemLoading(false)

    // }

    const onSubmit = async (currentValues) => {

        const document = {
            doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
            doc_remark: currentValues.remark,
        }

        const props = {
            location_id: currentValues.locationId
        }

        let items = [];

        currentValues.rows.forEach((item, index) => {

            // get the saved inventory batched selection from hook state
            const selected = getSelectedInventoryBatch({ selectedIndexNo: index })

            items.push({
                id: item?.itemId,
                code: item?.code,
                name: item?.name,
                description: item?.description,
                qty: item?.qty.value,
                uom_lbl: item?.uomName,
                uom: item?.uomId,
                price: item?.price,
                props: {
                    relocate_slot_id: item?.slotId
                },
                deductions: {
                    slot_id: selected?.slotId,
                    custom_batch_no: selected?.customBatchNo,
                    expiry_date: selected?.expiryDate
                }
            })

        })

        try {

            let data = {
                document,
                props,
                items,
                ...getFormikDependencyStates({ values })
            }

            const response = await create({ data });

            console.log('response', response)

            promptMessage(true, `${response?.message}`, response)

            navigate(getRoute(`documents/itemRelocate/view/${response?.data?.document?.id}`))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue, } = formik;

    const {
        isLoading: isLoadingInventoryBatches,
        skipBatchId,
        // skipIndexNoArray,
        dataInventoryBatches,
        resetDataInventoryBatches,
        selectInventoryBatch,
        getInventoryBatchesByItemId,
        getSelectedInventoryBatch,
        appendInventoryBatch,
        removeAllSelectedIndexNo,
        RenderValueComponent,
        RenderSubHeaderComponent,
        RenderMenuItemComponent,
    } = useStateInventoryBatches({
        locationId: values.locationId
    })

    useEffect(() => {

        const currentLocationIds = getLocationIds();

        // setSelectLocationIds(currentLocationIds)

        if (currentLocationIds.length === 0) {
            // console.log('currentLocationIds', currentLocationIds, availableLocations)

            // get the location information
            const loc = availableLocations.filter(item => item.id === currentLocationIds[0])

            if (loc.length) {
                setFieldValue("locationId", loc[0].id)
                setFieldValue("locationName", loc[0].location_name)
            }
        }

    }, [getLocationIds])

    useEffect(() => {

        catchTransition({ formik })

    }, [])

    useEffect(() => {

        // get the location racks and slots
        if (values?.locationId) {
            fetchDataRacks(values.locationId)
            // console.log('loc', values.locationId)
        }

    }, [values.locationId])

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push({
                displayText: t("loadFrom"),
                onClick: () => {

                    // check the location is selected - valid
                    if (validateLocationSelection() === false) {
                        promptMessage(false, t(`pleaseSelectAnyLocation`))
                        return false;
                    }

                    setLoadDocumentConfig(prev => ({ ...prev, show: true }))

                    return true;
                }
            })
        }

        return props
    }

    // able to filter out the inventory batches been selected even for the same uom id
    const getAvailableInventoryBatches = ({ index, itemId }) => {

        const selected = getInventoryBatchesByItemId({ itemId, selectedIndexNo: index })

        // get the row type of the state
        const rowFromType = values.rows[index].rowFromType

        if (!rowFromType) return []

        let data = selected.filter(i => i.batchId !== 'skip')

        // console.log('selected', data, rowFromType)

        // if the row type is normal
        if (rowFromType === 'normal') {
            data = data.filter(i => i.rackType !== 'reserve')
        }

        // if the row type is reserve
        if (rowFromType === 'reserved') {
            data = data.filter(i => i.rackType === 'reserve')
        }

        return data;
    }

    const validateLocationSelection = () => {
        // return (selectLocationIds && selectLocationIds.length === 1)
        // const selected = getLocationIds()
        // return selected && selected.length === 1
        return values?.locationId
    }

    const updateStateFromSearchDocument = (props) => {

        try {

            // check the location is selected - valid
            if (validateLocationSelection() === false) {
                promptMessage(false, t(`pleaseSelectAnyLocation`))
                return false;
            }

            updateFormikState({
                data: props?.data,
                routeType,
                setFieldValue,
            })


        } catch (error) {
            promptMessage(false, `Load failed : ${error}`)
        }

        return true;
    }

    const handleAddItem = ({ rows, setFieldValue }) => {

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`itemsAtLeastHave1Row`))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    const getRacks = () => {

        return rackData
    }

    const getSlots = ({ rackId }) => {

        if (!rackId) return []

        const rack = rackData.filter(item => item.id === rackId)

        return rack && rack.length ? rack[0]._slots : []
    }

    const RenderRackSelect = ({
        index,
        itemValues,
        itemErrors,
        itemTouched
    }) => {

        const allRacks = getRacks();

        if (!allRacks) return <></>

        let availableRacks = [];

        // check if the row to type
        if (itemValues.rowToType === 'normal') {
            availableRacks = allRacks.filter(i => i.rack_type !== 'reserve')
        } else {
            availableRacks = allRacks.filter(i => i.rack_type === 'reserve')
        }


        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
                error={Boolean(itemTouched?.rackId) && Boolean(itemErrors?.rackId)}
            >
                <InputLabel id="rack-label">{t('rack')}</InputLabel>
                <Select
                    labelId="rack-label"
                    id="rack_id"
                    value={itemValues?.rackId}
                    name={`rackId`}
                    label={t('rack')}
                    margin="dense"
                    size="small"
                    onChange={(event) => {
                        setFieldValue(`rows.${index}.rackId`, event.target.value)
                    }}
                >
                    {
                        availableRacks.map((item, index) =>
                            <MenuItem key={index} value={item.id}>
                                {item.rack_name}
                            </MenuItem>
                        )
                    }
                </Select>
                <FormHelperText>
                    {itemTouched?.rackId && itemErrors?.rackId}
                </FormHelperText>
            </FormControl>
        )
    }

    const RenderSlotSelect = ({
        index,
        itemValues,
        itemErrors,
        itemTouched
    }) => {

        // if(!values.rackId) return <></>

        const items = getSlots({ rackId: itemValues?.rackId });

        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
                error={Boolean(itemTouched?.slotId) && Boolean(itemErrors?.slotId)}
            >
                <InputLabel id="documentType">{t('slot')}</InputLabel>
                <Select
                    id="slotSelection"
                    value={itemValues?.slotId}
                    name='slot'
                    label={t('slot')}
                    margin="dense"
                    size="small"
                    onChange={(event) => {
                        setFieldValue(`rows.${index}.slotId`, event.target.value)
                    }}
                >
                    {
                        items.map((item, index) => <MenuItem key={index} value={item.id}>{item.name}</MenuItem>)
                    }
                </Select>
                <FormHelperText>
                    {itemTouched?.slotId && itemErrors?.slotId}
                </FormHelperText>
            </FormControl>
        )

    }

    const RenderRowTypeButtons = ({
        actionType,
        index,
        itemValues,
        itemErrors,
        itemTouched
    }) => {
        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
            // error={Boolean(itemErrors?.rowType)}
            >
                <ButtonGroup
                    variant="outlined"
                    aria-label="outlined button group"
                    disabled={isLoadingInventoryBatches}
                    sx={{
                        // mt: 1
                    }}
                    size="small"
                // orientation="vertical"
                >
                    {
                        actionType === "from" ?
                            (
                                <>
                                    <Tooltip title={`relocateFromNormalRacks`}>
                                        <Button
                                            fullWidth
                                            variant={itemValues?.rowFromType === 'normal' ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setFieldValue(`rows.${index}.rowFromType`, 'normal')
                                                setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })
                                                removeAllSelectedIndexNo({ itemId: itemValues.itemId, selectedIndexNo: index })
                                            }}
                                        >
                                            {t('normal')}
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title={t(`relocateFromReservedRacks`)}>
                                        <Button
                                            fullWidth
                                            variant={itemValues?.rowFromType === 'reserved' ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setFieldValue(`rows.${index}.rowFromType`, 'reserved')
                                                setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })
                                                removeAllSelectedIndexNo({ itemId: itemValues.itemId, selectedIndexNo: index })
                                            }}
                                        >
                                            {t('reserved')}
                                        </Button>
                                    </Tooltip>
                                </>
                            )
                            :
                            (
                                <>
                                    <Tooltip title={`Relocate to Normal Racks`}>
                                        <Button
                                            fullWidth
                                            variant={itemValues?.rowToType === 'normal' ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setFieldValue(`rows.${index}.rowToType`, 'normal')
                                                setFieldValue(`rows.${index}.slotId`, '')
                                                setFieldValue(`rows.${index}.rackId`, '')
                                                // setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })
                                                // removeAllSelectedIndexNo({ itemId: itemValues.itemId, selectedIndexNo: index })
                                            }}
                                        >
                                            {t('normal')}
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title={`Relocate to Reserved Racks`}>
                                        <Button
                                            fullWidth
                                            variant={itemValues?.rowToType === 'reserved' ? 'contained' : 'outlined'}
                                            onClick={() => {
                                                setFieldValue(`rows.${index}.rowToType`, 'reserved')
                                                setFieldValue(`rows.${index}.slotId`, '')
                                                setFieldValue(`rows.${index}.rackId`, '')
                                                // setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })
                                                // removeAllSelectedIndexNo({ itemId: itemValues.itemId, selectedIndexNo: index })
                                            }}
                                        >
                                            {t('reserved')}
                                        </Button>
                                    </Tooltip>
                                </>
                            )
                    }

                </ButtonGroup>
            </FormControl>
        )
    }

    const RenderRows = () => {

        const rows = values?.rows;

        return (
            <Box
            >
                <Box
                >
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                // <Grid key={index} item xs={12} sm={12} md={12}>

                                <Grid key={index} container spacing={1} sx={{ mb: 2 }}>

                                    <Grid item xs={12} sm={12} md={0.5} display={"flex"} flexDirection={"column"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <IconButton
                                            aria-label="delete"
                                            onClick={() => handleRemoveItem({ rows: values.rows, index, setFieldValue })}
                                            sx={{
                                                mt: 1
                                            }}
                                        >
                                            <CommonIcons name={icons.remove} />
                                        </IconButton>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={2.5}>

                                        <SearchItems
                                            id={`rows.${index}.name`}
                                            handleOnCancel={() => { }}
                                            handleOnSearchChange={(event) => {
                                                setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                                            }}
                                            handleOnSelect={({ id, item }) => {

                                                // console.log('id', id, item)

                                                appendInventoryBatch({ itemId: item?.id, selectedIndexNo: index })

                                                setFieldValue(`rows.${index}.itemId`, item?.id)
                                                setFieldValue(`rows.${index}.productId`, item?.product_id)
                                                setFieldValue(`rows.${index}.transformRatio`, item?.transform_ratio)

                                                setFieldValue(`rows.${index}.name`, item?.item_name)
                                                setFieldValue(`rows.${index}.description`, item?.description)
                                                setFieldValue(`rows.${index}.code`, item?.code)
                                                setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                                                setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                                                // setFieldValue(`rows.${index}.price`, item?.uom_price)
                                                setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0) })

                                                setFieldValue(
                                                    `rows.${index}.isDefaultUom`,
                                                    item?.id === item?.default_uom_item_id
                                                )

                                            }}
                                            textProps={{
                                                disabled: true,
                                                value: itemValues?.name ? itemValues.name : "",
                                                error: Boolean(itemErrors?.name),
                                                helperText: itemErrors?.name
                                            }}
                                        />

                                        {
                                            (itemValues?.itemId) &&
                                            <>
                                                <Chip
                                                    label={`${itemValues.code} (${itemValues.uomName})`}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                                {
                                                    itemValues.isDefaultUom &&
                                                    <Chip
                                                        label={t(`defaultUom`)}
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                }
                                            </>
                                        }

                                    </Grid>

                                    <Grid item xs={12} sm={12} md={5}>

                                        <Card
                                            sx={{
                                                px: 1,
                                                py: 1,
                                            }}
                                        >

                                            <Grid container spacing={0}>

                                                <Grid item xs={6} sm={6} md={4} alignItems={"center"} justifyItems={"center"} display={"flex"}>
                                                    <Chip
                                                        label={t("from")}
                                                        size="small"
                                                        variant="contained"
                                                        // color={"warning"}
                                                        sx={{
                                                            backgroundColor: orange[400],
                                                            fontWeight: 700
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={6} sm={6} md={8}
                                                    textAlign={"right"}
                                                >
                                                    <Box
                                                        sx={{
                                                            zIndex: 999
                                                        }}
                                                    >
                                                        {
                                                            RenderRowTypeButtons({
                                                                actionType: "from",
                                                                index,
                                                                itemValues,
                                                                itemErrors,
                                                                itemTouched
                                                            })
                                                        }
                                                    </Box>
                                                </Grid>

                                            </Grid>

                                            <Grid container spacing={1}>

                                                {/* inventoryBatches */}
                                                <Grid item xs={6} sm={6} md={8}>

                                                    {
                                                        isLoadingInventoryBatches ?
                                                            (
                                                                <TextField
                                                                    margin="dense"
                                                                    size="small"
                                                                    fullWidth
                                                                    placeholder="Loading..."
                                                                    type="text"
                                                                    variant="outlined"
                                                                />
                                                            )
                                                            :
                                                            (
                                                                <FormControl
                                                                    margin="dense"
                                                                    fullWidth
                                                                    size="small"
                                                                    error={Boolean(itemErrors?.inventoryBatchId)}
                                                                >
                                                                    <InputLabel id="inventoryBatchId">{t('inventory')}</InputLabel>
                                                                    <Select
                                                                        disabled={
                                                                            !(itemValues?.itemId)
                                                                        }
                                                                        labelId="inventoryBatchId"
                                                                        label={t("inventory")}
                                                                        name={`rows.${index}.inventoryBatchId`}
                                                                        // onChange={handleChange}
                                                                        onChange={(event) => {

                                                                            // console.log('event', event.target.value)

                                                                            let batchId = event.target.value

                                                                            const selectedBatch = selectInventoryBatch({
                                                                                itemId: itemValues.itemId,
                                                                                batchId,
                                                                                selectedIndexNo: index
                                                                            })

                                                                            // console.log('selectedBatch', selectedBatch)

                                                                            setFieldValue(`rows.${index}.inventoryBatchId`, batchId)
                                                                            setFieldValue(`rows.${index}.inventoryCustomBatchNo`, selectedBatch?.customBatchNo)
                                                                            setFieldValue(`rows.${index}.inventoryExpiryDate`, selectedBatch?.expiryDate)

                                                                            setFieldValue(
                                                                                `rows.${index}.qty`,
                                                                                {
                                                                                    value: "0",
                                                                                    maxQty: parseFloat(selectedBatch?.totalRemainQty),
                                                                                }
                                                                            )

                                                                        }}
                                                                        renderValue={(value) => {

                                                                            const a = getSelectedInventoryBatch({ selectedIndexNo: index })

                                                                            return (
                                                                                <RenderValueComponent item={a} />
                                                                            )
                                                                        }}
                                                                        value={
                                                                            getSelectedInventoryBatch({ selectedIndexNo: index })?.batchId ?
                                                                                getSelectedInventoryBatch({ selectedIndexNo: index }).batchId
                                                                                :
                                                                                ""
                                                                        }
                                                                        sx={{
                                                                            textAlign: 'left',
                                                                        }}
                                                                        MenuProps={{
                                                                            MenuListProps: {
                                                                                sx: {
                                                                                    py: 0,
                                                                                },
                                                                            }
                                                                        }}
                                                                    >
                                                                        <RenderSubHeaderComponent />
                                                                        {
                                                                            getAvailableInventoryBatches({ index, itemValues, itemId: itemValues.itemId }).map((i, index2) => {
                                                                                return (
                                                                                    // <RenderMenuItemComponent
                                                                                    //     key={index2}
                                                                                    //     index={index2}
                                                                                    //     item={i}
                                                                                    // />
                                                                                    RenderMenuItemComponent({
                                                                                        key: index2,
                                                                                        index: index2,
                                                                                        item: i,
                                                                                        style: {
                                                                                            width: 500,
                                                                                        }
                                                                                    })
                                                                                )
                                                                            })
                                                                        }
                                                                    </Select>
                                                                    <FormHelperText>
                                                                        {
                                                                            itemErrors?.inventoryBatchId ?
                                                                                itemErrors?.inventoryBatchId
                                                                                :
                                                                                getSelectedInventoryBatch({ selectedIndexNo: index })?.batchId ?
                                                                                    getSelectedInventoryBatch({ selectedIndexNo: index }).label
                                                                                    :
                                                                                    ""
                                                                        }
                                                                    </FormHelperText>
                                                                </FormControl>
                                                            )
                                                    }

                                                </Grid>

                                                <Grid item xs={6} sm={6} md={4}>
                                                    <TextField
                                                        disabled={
                                                            itemValues?.inventoryBatchId ? Boolean(false) : Boolean(true)
                                                        }
                                                        margin="dense"
                                                        size="small"
                                                        fullWidth
                                                        name={`rows.${index}.qty`}
                                                        label={`${t('qty')} ${itemValues?.uomName ? "(".concat(itemValues.uomName).concat(")") : ""}`}
                                                        type="text"
                                                        variant="outlined"
                                                        value={
                                                            itemValues?.qty?.value ? itemValues.qty.value : ""
                                                        }
                                                        onChange={(event) => {
                                                            setFieldValue(
                                                                `rows.${index}.qty`,
                                                                {
                                                                    value: event.target.value,
                                                                    maxQty: parseFloat(itemValues.qty.maxQty),
                                                                    // skipStockPost: itemValues.qty.skipStockPost
                                                                }
                                                            )
                                                        }}
                                                        onFocus={event => {
                                                            event.target.select();
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {
                                                                        `/ ${itemValues?.qty?.maxQty}`
                                                                    }
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        error={Boolean(itemErrors?.qty?.value)}
                                                        helperText={itemErrors?.qty?.value}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </Card>

                                    </Grid>

                                    <Grid item xs={12} sm={12} md={4}>

                                        <Card
                                            sx={{
                                                px: 1,
                                                py: 1,
                                            }}
                                        >

                                            <Grid container spacing={0}>

                                                <Grid item xs={6} sm={6} md={4} alignItems={"center"} justifyItems={"center"} display={"flex"}>
                                                    <Chip
                                                        label={t("to")}
                                                        size="small"
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: orange[400],
                                                            fontWeight: 700
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={6} sm={6} md={8}
                                                    textAlign={"right"}
                                                >
                                                    <Box
                                                        sx={{
                                                            zIndex: 999
                                                        }}
                                                    >
                                                        {
                                                            RenderRowTypeButtons({
                                                                actionType: "to",
                                                                index,
                                                                itemValues,
                                                                itemErrors,
                                                                itemTouched
                                                            })
                                                        }
                                                    </Box>
                                                </Grid>

                                            </Grid>

                                            <Grid container spacing={1}>

                                                <Grid item md={6} xs={6} sm={6}>
                                                    {
                                                        RenderRackSelect({
                                                            index,
                                                            itemValues,
                                                            itemErrors,
                                                            itemTouched
                                                        })
                                                    }
                                                </Grid>

                                                <Grid item md={6} xs={6} sm={6}>
                                                    {
                                                        RenderSlotSelect({
                                                            index,
                                                            itemValues,
                                                            itemErrors,
                                                            itemTouched
                                                        })
                                                    }
                                                </Grid>

                                                {/* {
                                                    RenderTransformToDefaultUom({
                                                        itemValues,
                                                        index
                                                    })
                                                } */}

                                            </Grid>

                                        </Card>

                                    </Grid>


                                </Grid>
                            )
                        })
                    }
                </Box>

                <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid>

                {
                    RenderSummaryRow({ values, errors, touched, handleChange, setFieldValue })
                }

            </Box>
        )
    }

    const RenderSummaryRow = () => {
        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={4}>

                        <Button
                            variant="outlined"
                            sx={{ mt: 2 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.add} />}
                            onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
                        >
                            {t('addItem')}
                        </Button>

                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>
                        <></>
                    </Grid>

                    {/* <Grid item xs={12} sm={12} md={3}>
                        <TextField
                            inputProps={{
                                style: {
                                    textAlign: "right"
                                }
                            }}

                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CommonIcons name={icons.discount} />
                                    </InputAdornment>
                                ),
                            }}
                            
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"discount"}
                            label="Discount"
                            type="text"                                         
                            variant="outlined"
                            value={values.discount}
                            onChange={(event) => {
                                setFieldValue(`discount`, event.target.value);
                                // handleDisplaySummaryChange({ discount: event.target.value});
                            }}
                            error={touched.discount && Boolean(errors.discount)}
                            helperText={touched.discount && errors.discount}
                        />
                    </Grid> */}

                </Grid>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={9}>
                        <></>
                    </Grid>

                    {/* <Grid item xs={12} sm={12} md={1}>
                        <Typography sx={{ mt: 2, mp: 2}}>
                        Discount
                        </Typography>
                    </Grid> */}

                    {/* <Grid item xs={12} sm={12} md={3}>
                        <TextField
                            inputProps={{
                                style: {
                                    textAlign: "right"
                                }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Typography
                                            sx={{
                                                fontSize: '1.5rem',
                                                fontWeight: 600
                                            }}
                                        >
                                            =
                                        </Typography>
                                    </InputAdornment>
                                ),
                            }}
                            margin="dense"
                            size="small"
                            disabled
                            fullWidth
                            name={"totalamount"}
                            label="Total Amount"
                            type="text"                                         
                            variant="outlined"
                            value={values?.totalamount? values.totalamount : "0.00"}
                        />
                    </Grid> */}

                </Grid>

            </Grid>
        )
    }

    const RenderFormLocation = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`location`)}
                            subTitle={t(`relatedWarehouseLocationToProcess`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={10.5}>
                        <TextField
                            disabled
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"locationId"}
                            label={t("location")}
                            type="text"
                            variant="outlined"
                            value={values.locationName}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                        />
                    </Grid>
                    <Grid item md={1.5}>
                        <IconButton
                            color="primary"
                            sx={{
                                // pt: 0
                            }}
                            onClick={() => {
                                // setLocationIds([])
                                setFieldValue("locationId", "")
                                setFieldValue("locationName", "")
                                setFieldValue(`rows`, [initialRowValues])
                                resetDataInventoryBatches()
                            }}
                        >
                            <StyledIcon
                                sx={{
                                    width: 25,
                                    height: 25,
                                    m: 0,
                                    p: 0
                                }}
                            >
                                <CommonIcons name={icons.edit} />
                            </StyledIcon>
                        </IconButton>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name: "documentDate",
                                        label: t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        return (
            <form onSubmit={handleSubmit}>
                {/* {JSON.stringify(errors)} */}
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {
                            RenderFormLocation()
                        }

                        {/* {
                            RenderFormProfiles()
                        } */}

                    </Grid>

                </Grid>
                <StyledCard sx={{ mt: 1 }}>
                    <Grid container rowSpacing={0}>
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t(`items`)}
                                subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            {
                                RenderRows()
                            }

                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoading}
                        >
                            {t('saveChanges')}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </form>
        )
    }

    const RenderAll = () => {
        return validateLocationSelection() ?
            (
                RenderForm()
            )
            :
            (
                <LocationSelector
                    config={{
                        title: t("selectOnly1Location"),
                        description: t("youHaveToSelectAnyoneOfTheWarehouseLocationToProceed")
                    }}
                    maxSelect={1}
                    handleOnNext={({ selected }) => {

                        // console.log('selected', selected)

                        // setLocationIds([selected[0].id])
                        setFieldValue(`locationId`, selected[0].id)
                        setFieldValue(`locationName`, selected[0].location_name)

                    }}
                />
            )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newItemRelocate })
            }

            {/* {
                JSON.stringify(dataItemUoms)
            } */}

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newItemRelocate")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("itemRelocates"),
                        props: {
                            href: getRoute('documents/itemRelocates')
                        }
                    },
                    {
                        displayText: t("newItemRelocate"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderAll()
                    :
                    <CommonRestricted />
            }

            {
                loadDocumentConfig?.show &&

                <LoadFromDocuments
                    fromDocumentId={loadDocumentConfig?.documentId}
                    fromDocumentType={loadDocumentConfig?.documentType}
                    show={loadDocumentConfig?.show}
                    filledSearchKeyword={loadDocumentConfig?.keyword}
                    handleOnCancel={() => {
                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSelect={(props) => {

                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))

                        // load the data into the state
                        updateStateFromSearchDocument(props)

                    }}
                />
            }

        </Box>
    )
}